import { render, staticRenderFns } from "./UserInjuries.vue?vue&type=template&id=2171f9b8&"
import script from "./UserInjuries.vue?vue&type=script&lang=js&"
export * from "./UserInjuries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports